const detentionConstants = {
  validDetentionHeaders: {
    'Vehicle Name': 'vechile_name',
    'Group Code': 'group_code',
    Movement: 'movement',
    LOADING_DETENTION_DAY1: 'loading_detention_day_1',
    LOADING_DETENTION_DAY2: 'loading_detention_day_2',
    LOADING_DETENTION_DAY3: 'loading_detention_day_3',
    LOADING_DETENTION_DAY4: 'loading_detention_day_4',
    LOADING_DETENTION_DAY5: 'loading_detention_day_5',
    LOADING_DETENTION_MORETHAN_DAY5: 'loading_detention_day_6',
    UNLOADING_DETENTION_DAY1: 'unloading_detention_day_1',
    UNLOADING_DETENTION_DAY2: 'unloading_detention_day_2',
    UNLOADING_DETENTION_DAY3: 'unloading_detention_day_3',
    UNLOADING_DETENTION_DAY4: 'unloading_detention_day_4',
    UNLOADING_DETENTION_DAY5: 'unloading_detention_day_5',
    UNLOADING_DETENTION_MORETHAN_DAY5: 'unloading_detention_day_6',
    TRANSIT_DAY1: 'transit_day_1',
    TRANSIT_DAY2: 'transit_day_2',
    TRANSIT_DAY3: 'transit_day_3',
    TRANSIT_DAY4: 'transit_day_4',
    TRANSIT_DAY5: 'transit_day_5',
    TRANSIT_MORETHAN_DAY5: 'transit_day_6',
    TRANSIT_DELAY_FACTOR: 'transit_delay_factor',
  },
  loadingDetentionType: {
    ACTUAL_ARRIVED: 1,
    EXPECTED_LOADING: 2,
  },
  unloadingDetentionType: {
    ONLY_DETENTION: 1,
    DETENTION_WITH_TRANSIT: 2,
  },
};

const defaultDetentionGroup = 'U';

const detentionTypes = {
  LOADING: 'Loading',
  UNLOADING: 'Unloading',
};

module.exports = { defaultDetentionGroup, detentionTypes, detentionConstants };
